import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReportsSection from '../components/ReportDropdown2';
import LocationPicker from '../pages/LocationPicker';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { updateProfile } from "firebase/auth";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaEnvelope, FaTimes } from 'react-icons/fa';

const DocumentRegistrationPage = () => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [searchError, setSearchError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [pdfDownloaded, setPdfDownloaded] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const pdfRef = useRef();
  const [showSharePopup, setShowSharePopup] = useState(false);

  const handleShare = async (platform) => {
    if (!pdfDownloaded) {
      alert('Please download the PDF first before sharing');
      return;
    }
    
    const pdfUrl = `Registration_${registrationNumber || 'Document'}.pdf`;
    const shareText = `Please check out my registration document: ${pdfUrl}`;
    
    switch(platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pdfUrl)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'linkedin':
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pdfUrl)}&title=${encodeURIComponent('Registration Document')}&summary=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=Registration Document&body=${encodeURIComponent(shareText)}`);
        break;
      default:
        break;
    }
  };

  const displayData = searchResults || location.state || {};

  const {
    personalInfo = {},
    organizationInfo = {},
    dropdownSelections = {},
    reportSelections: initialReportSelections = {
      COUNTRY: "--",
      REGION: "--",
      DISTRICT: "--",
      MUNICIPALITY: "--",
      SMMEs: "--",
      "VALUE CHAIN": "--",
      "TYPE OF FARMING": "--",
      "USER TYPE": "--"
    },
    selectedLanguage = null,
    landData = {},
    selectedSkills = [],
    membershipData = {},
    selectedExperience = [],
    focusSelected = [],
    sectionD = {},
    industry = {},
    setaQualification = {},
    location: userLocation = null,
    registrationNumber = '',
    idDocumentUrl = '',
    profileImage = null,
    productImages = [],
    certificatesUrls = [],
    formData,
    orgType = ''
  } = displayData;

  const safeFormData = {
    firstName: '',
    surname: '',
    mobile: '',
    email: '',
    physicalAddress: '',
    idNumber: '',
    ...formData
  };

  const safeLandData = {
    type1: landData?.type1 || { type: "", size: "", unit: "" },
    type2: landData?.type2 || { type: "", size: "", unit: "" },
    erfNumber: landData?.erfNumber || ''
  };

  const safeSectionD = {
    focusSelected: focusSelected || [],
    selectedType: sectionD.selectedType || '',
    selectedOption: sectionD.selectedOption || '',
    selectedCategories: sectionD.selectedCategories || [],
    ...sectionD
  };

  const safeIndustry = {
    selectedChallenges: (industry.selectedChallenges || []).map(challenge => {
      if (typeof challenge === 'string') {
        return {
          title: challenge,
          description: '',
          solution: ''
        };
      }
      return {
        id: challenge.id || "",
        title: challenge.title || "Not provided",
        description: challenge.description || "",
        solution: challenge.solution || "",
        code: challenge.code || ""
      };
    }),
    vision: industry.vision || 'Not provided'
  };
  
  const safeSetaQualification = {
    selectedS: setaQualification.selectedS || '',
    selectedQ: setaQualification.selectedQ || '',
    ...setaQualification
  };

  const safeMembershipData = {
    selected: membershipData.selected || '',
    custom: membershipData.custom || ''
  };

  const [imageStatus, setImageStatus] = useState({
    profile: { loaded: false, url: null },
    products: [],
    certificates: []
  });

  const reportSelections = displayData.reportSelections || initialReportSelections;
// In PDFPreviewPage.jsx, update the safeReportSelections section to handle null values:

const safeReportSelections = {
  COUNTRY: reportSelections?.COUNTRY 
    ? (typeof reportSelections.COUNTRY === 'object' 
        ? reportSelections.COUNTRY.name 
        : reportSelections.COUNTRY)
    : "--",
  REGION: reportSelections?.REGION
    ? (typeof reportSelections.REGION === 'object'
        ? reportSelections.REGION.name
        : reportSelections.REGION)
    : "--",
  DISTRICT: reportSelections?.DISTRICT
    ? (typeof reportSelections.DISTRICT === 'object'
        ? reportSelections.DISTRICT.name
        : reportSelections.DISTRICT)
    : "--",
  MUNICIPALITY: reportSelections?.MUNICIPALITY || "--",
  SMMEs: typeof reportSelections?.SMMEs === 'object' 
    ? reportSelections.SMMEs.label || reportSelections.SMMEs.value 
    : reportSelections?.SMMEs || "--",
  "TYPE OF FARMING": reportSelections?.["TYPE OF FARMING"] || "--",
  "VALUE CHAIN": reportSelections?.["VALUE CHAIN"] || "--",
  "USER TYPE": reportSelections?.["USER TYPE"] || "--"
};
  const SMMEsOptions = [
    {
      heading: "Agriculture and Agri business",
      items: [  
        { label: "Smallholder farms", value: "SMF" },
        { label: "Agro-processing", value: "AGP" },
        { label: "Agri-input suppliers", value: "AIP" },
        { label: "Horticulture businesses", value: "HCB" },
        { label: "Poultry", value: "POF" },
        { label: "Fish farms", value: "FIF" },
        { label: "Agri-tech startups", value: "ATC" }
      ]
    }
  ];

  const boxPlaceholders = [
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
    "XXXXXXX",
  ];

  const handleSearch = async () => {
    try {
      setIsLoading(true);
      setSearchError('');
      
      if (!searchTerm.trim()) {
        setSearchError('Please enter a registration number');
        setIsLoading(false);
        return;
      }
      
      const registrationsRef = collection(db, 'registrations');
      const q = query(
        registrationsRef, 
        where('registrationNumber', '==', searchTerm.trim().toUpperCase())
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setSearchError('No registration found with that number');
        setSearchResults(null);
        setIsLoading(false);
        return;
      }
      
      const doc = querySnapshot.docs[0];
      const data = doc.data();
      
      setSearchResults({
        ...data,
        formData: data.personalInfo || {},
        orgFormData: data.organizationInfo || {},
        landData: data.landData || {},
        membershipData: {
          selected: data.membership || '',
          custom: data.customMembership || ''
        },
        selectedExperience: data.groupExperience || [],
        focusSelected: data.sectionD?.focusSelected || [],
        industry: {
          selectedChallenges: data.industry?.selectedChallenges || [],
          vision: data.industry?.vision || ''
        },
        sectionD: data.sectionD || {},
        setaQualification: data.setaQualification || {},
        profileImage: data.personalInfo?.profileImage || null,
        productImages: data.organizationInfo?.productImages || [],
        certificatesUrls: data.organizationInfo?.certificates || [],
        idDocumentUrl: data.organizationInfo?.idDocument || '',
        registrationNumber: data.registrationNumber || ''
      });
      
    } catch (error) {
      console.error('Search error:', error);
      setSearchError('Error searching for registration');
    } finally {
      setIsLoading(false);
    }
  };

  const [isPrintReady, setIsPrintReady] = useState(false);

  useEffect(() => {
    const processImages = () => {
      try {
        let profileUrl = null;
        if (profileImage) {
          profileUrl = profileImage.cloudinaryUrl || profileImage.previewUrl || profileImage;
        }

        const productUrls = (productImages || []).map(img => 
          img?.cloudinaryUrl || img?.previewUrl || img
        ).filter(Boolean);

        const certUrls = (certificatesUrls || []).map(cert => 
          cert?.url || cert?.previewUrl || cert
        ).filter(Boolean);

        setImageStatus({
          profile: {
            loaded: !!profileUrl,
            url: profileUrl
          },
          products: productUrls.map(url => ({
            loaded: true,
            url
          })),
          certificates: certUrls.map(url => ({
            loaded: true,
            url
          }))
        });
        setIsPrintReady(true);
      } catch (error) {
        console.error('Error processing images:', error);
      }
    };

    if (profileImage || productImages?.length || certificatesUrls?.length) {
      processImages();
    }
  }, [profileImage, productImages, certificatesUrls]);

  const formatDate = (dateString) => {
    if (!dateString) return 'Not provided';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid date';
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (e) {
      console.error('Date formatting error:', e);
      return 'Invalid date';
    }
  };

  const handleDownloadPDF = async () => {
    if (!pdfRef.current) {
      console.error('No content to print');
      return;
    }
  
    setIsDownloading(true);
    setPdfDownloaded(false);
    
    try {
      const element = pdfRef.current;
      const originalStyles = {
        overflow: element.style.overflow,
        height: element.style.height,
      };
      
      // Apply print-specific styles
      element.style.overflow = 'visible';
      element.style.height = 'auto';
      element.style.width = '100%';
      element.style.padding = '0';
      element.style.margin = '0';
  
      // Temporarily hide elements that shouldn't appear in PDF
      const elementsToHide = document.querySelectorAll('.no-print');
      elementsToHide.forEach(el => {
        el.style.display = 'none';
      });
  
      // Calculate the total height of your content
      const totalContentHeight = element.scrollHeight;
      const pageHeightMM = 297; // A4 height in mm
      const targetPages = 3;
      const maxContentHeightPx = (totalContentHeight * targetPages * pageHeightMM) / (pageHeightMM * targetPages);
  
      // Determine the optimal scale to fit content in 3 pages
      const optimalScale = Math.min(1, (pageHeightMM * targetPages * 3.78) / totalContentHeight); // 3.78 px/mm
  
      const canvas = await html2canvas(element, {
        scale: optimalScale, // Dynamic scale based on content
        useCORS: true,
        allowTaint: true,
        scrollY: -window.scrollY,
        windowHeight: element.scrollHeight,
        letterRendering: true,
        logging: true,
        backgroundColor: '#FFFFFF'
      });
  
      // Restore original styles
      element.style.overflow = originalStyles.overflow;
      element.style.height = originalStyles.height;
      
      // Restore hidden elements
      elementsToHide.forEach(el => {
        el.style.display = '';
      });
  
      const imgData = canvas.toDataURL('image/jpeg', 0.85); // Good balance of quality/size
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  
      // Calculate how much to fit on each page
      const pageHeight = pdf.internal.pageSize.getHeight();
      const contentPerPage = pdfHeight / targetPages;
      
      // Add content spread across exactly 3 pages
      for (let i = 0; i < targetPages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        
        const position = i * contentPerPage;
        const height = Math.min(contentPerPage, pdfHeight - position);
        
        pdf.addImage(
          imgData, 
          'JPEG', 
          0, 
          -position, 
          pdfWidth, 
          pdfHeight
        );
      }
  
      pdf.save(`Registration_${registrationNumber || 'Document'}.pdf`);
      setPdfDownloaded(true);
    } catch (error) {
      console.error('Error generating PDF:', error);
      setPdfDownloaded(false);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="bg-gray-100 p-4 md:p-8">
      <div className="max-w-7xl mx-auto bg-white p-2 md:p-8 rounded-lg shadow-lg">
        {/* Search and Header Section - Not included in PDF */}
        <div className='bg-[#E7EBEB] p-4 md:p-10 mb-4 no-print'>
          <div className="text-left md:mt-5 mb-4 md:mb-8">
            <h1 className="text-lg md:text-[54px] text-center font-extrabold text-black">REGISTRATION</h1>
          </div>
          
          <div className="flex flex-row items-center mb-4">
            <input
              type="text"
              placeholder="Search by registration number"
              className="h-6 md:h-[60px] w-full md:text-[16px] text-[6px] rounded-[5px] border border-[#C4C4C4] placeholder:text-[6px]  placeholder:text-[#979797] placeholder:font-bold md:placeholder:text-[16px] px-4 mb-2 md:mb-0"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
          </div>
          <p className='text-[6px] md:text-[14px] font-normal mt-1 mb-1'>Search by entering user ID of farmer</p> 
          {searchError && <div className="text-red-500 text-center mb-4">{searchError}</div>}

          <div className='flex flex-row justify-between items-center mt-3 md:mt-5 gap-2'>
            <img 
              src='https://res.cloudinary.com/dzngpgki4/image/upload/v1748378882/FarmNet_Logo_Green_4_1_tpqgs5.png' 
              alt="Logo" 
              className='h-4 md:h-[35px]'
            />
            <div className='flex gap-1 md:gap-4 items-center w-full md:w-auto'>
              <div className="w-full">
                <div className="flex w-full">
                  <button
                    className={`w-[50px] md:w-[250px] h-5 md:h-[50px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                    <input 
                      className="text-[6px] md:text-[18px] px-1 md:px-2 bg-transparent outline-none placeholder-white w-full" 
                      placeholder={registrationNumber || 'XXXXXXXXX'}
                      readOnly
                    />
                  </button>
                  <div
                    className="w-5 h-5 md:h-[50px] md:w-[50px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-1 z-30 cursor-pointer"
                  >
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                      alt="expand"
                      className="w-3 h-3 md:w-6 md:h-[24px]"
                    />
                  </div>
                </div>
                <p className="text-[6px] md:text-[14px] font-normal mt-1 text-black">
                  Registration Number
                </p>
              </div>
              <div className="w-full">
                <div className="flex w-full">
                  <button 
                    className={`w-full md:w-[250px] h-5 md:h-[50px] bg-[#2E453D] text-white font-bold flex items-center md:px-1 rounded-l-[5px]`}
                    onClick={() => setShowSharePopup(true)}
                  >
                    <div className="text-[4px] md:text-[16px] px-0 text-center md:px-2 bg-transparent outline-none w-full">SHARE REGISTRATION</div>
                  </button>
                  <div 
                    className="w-5 h-5 md:h-[50px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-1 z-30 cursor-pointer"
                    onClick={() => setShowSharePopup(true)}
                  >
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                      alt="expand"
                      className="w-3 h-3 md:w-6 md:h-[24px]"
                    />
                  </div>
                </div>
                <p className="text-[6px] md:text-[14px] font-normal mt-1 text-black">
                  Save registration 
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* PDF Content */}
        <div 
          ref={pdfRef} 
          className="w-full bg-[#F3F5F5] mx-auto border border-gray-200 print-container"
          style={{
            overflow: 'visible',
            height: 'auto',
            width: '100%',
            padding: 0,
            margin: 0
          }}
        >
          <div className='p-4 md:p-10 print:p-2'>
            {/* User Registration Information */}
            <div className="flex md:flex-row justify-between items-center mb-6 md:mb-8 md:mt-5 print:mb-4">
              <div className="w-full md:w-1/2 mb-4 md:mb-0 md:-mt-4 print:w-1/2">
                <h2 className="text-[12px] md:text-[32px] font-bold print:text-[20px]">
                  {safeFormData.firstName || 'First Name'} {safeFormData.surname || 'Surname'}
                </h2>
                <p className="text-[6px] md:text-[24px] md:mt-2 font-semibold print:text-[14px]">
                  <span className='text-[#979797]'>ID No:</span> {registrationNumber || 'Not provided'}
                </p>
                <div className='h-0.5 md:h-[4px] bg-[#979797]/70 md:flex hidden mt-[12px] print:hidden'></div>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold md:mt-2 print:text-[12px]">Mobile: {safeFormData.mobile || 'Not provided'}</p>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Email: {safeFormData.email || 'Not provided'}</p>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Location: {safeFormData.physicalAddress || 'Not provided'}</p>
                <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Date: {formatDate(new Date().toISOString())}</p>
              </div>
              <div className="flex flex-col-reverse md:flex-row items-end gap-2 print:flex-col">
                <div className="print:text-[10px]">
                  <div className='h-0.5 md:h-[4.5px] bg-[#979797]/70 md:flex hidden print:hidden'></div>
                  <p className="text-[6px] md:text-[18px] text-[#979797] tracking-wider leading-snug md:leading-[1.80] font-light text-left md:max-w-[500px] mt-2 md:mt-6 print:text-[10px] print:mt-2">
                    To ensure this registration is authentic, scan the QR Code and verify against original information and report
                  </p>
                </div>
                <img 
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748029093/image_1740_srt7ks.png" 
                  alt="QR Code" 
                  className="w-16 h-16 md:w-[200px] md:h-[200px] mb-2 print:w-[100px] print:h-[100px]"
                />
              </div>
            </div>
            
            {/* Profile Image Section */}
{/* Profile Image Section */}
<div className="mb-6 md:mb-8 print:mb-4">
  {imageStatus.profile.loaded ? (
    <div className="w-full h-64 md:h-[450px] border border-gray-300 overflow-hidden print:h-[600px]">
      <img 
        src={imageStatus.profile.url} 
        alt="Profile" 
        className="w-full h-full object-cover"
        crossOrigin="anonymous"
        onError={(e) => {
          console.error('Error loading profile image:', imageStatus.profile.url);
          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyIDJDNi40NyAyIDIgNi40NyAyIDEyczQuNDcgMTAgMTAgMTAgMTAtNC40NyAxMC0xMFMxNy41MyAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4eiIvPjwvc3ZnPg==';
        }}
      />
    </div>
  ) : (
    <div className="w-full h-64 border border-gray-300 flex items-center justify-center print:h-[300px]">
      <span className='md:text-[30px] text-[8px] print:text-[12px]'>No profile image available</span>
    </div>
  )}
</div>

            {/* Individual Information Section */}
            <div className="mb-6 md:mb-8 print:mb-4">
              <h2 className="text-[8px] md:text-[36px] font-bold mb-3 md:mb-4 print:text-[20px]">
                <span className="text-[#979797]">INDIVIDUAL</span>{' '}
                <span className="text-[#152C24]">| INFORMATION</span>
              </h2>
              <div className="mt-2 md:mt-4 print:mt-2">
                <ReportsSection 
                  values={safeReportSelections}
                  isPreview={true}
                  smmesOptions={SMMEsOptions}
                  onChange={() => {}}
                  printMode={true}
                />
              </div>
            </div>
            
            {/* Product/Service Section */}
            {imageStatus.products.length > 0 && (
              <div className="mb-6 md:mb-8 print:mb-4">
                <h2 className="text-[8px] md:text-[36px] font-bold text-black print:text-[20px]">PRODUCTS | SERVICES</h2>
                <div className="grid grid-cols-4 md:grid-cols-4 gap-1.5 print:grid-cols-2 print:gap-1">
                  {imageStatus.products.map((img, index) => (
                    <div key={index} className="flex flex-col mt-2 md:mt-3 print:mt-2">
                      <p className="text-[8px] md:text-[24px] font-light italic md:mb-3 text-left  md:w-[260px] leading-tight print:text-[12px] print:min-h-[8px]">
                        {boxPlaceholders[index]}
                      </p>
                      <div className="relative bg-[#D9D9D9] rounded-[5px] h-20 md:h-[350px] w-full overflow-hidden print:h-[250px]">
                        {img.url ? (
                          <img
                            src={img.url}
                            alt={`Product ${index + 1}`}
                            className="object-cover w-full h-full"
                            crossOrigin="anonymous"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'data:image/svg+xml;base64,...';
                            }}
                          />
                        ) : (
                          <div className="flex items-center justify-center h-full">
                            <span className="print:text-[10px]">No image available</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {/* Documents Section */}
            {imageStatus.certificates.length > 0 && (
              <div className="mb-6 md:mb-8 mt-6 print:mb-4 print:mt-4">
                <h2 className="text-[8px] md:text-[36px] font-bold text-black  print:text-[20px]">DOCUMENTS</h2>
                <div className="grid grid-cols-4 md:grid-cols-4 gap-1.5 md:gap-2 print:grid-cols-2 print:gap-1">
                  {imageStatus.certificates.map((cert, index) => (
                    <div key={index} className="flex flex-col mt-2 md:mt-3 print:mt-2">
                      <p className="text-[8px] md:text-[24px] font-light italic md:mb-3 text-left  md:w-[260px] leading-tight print:text-[12px] print:min-h-[8px]">
                        {boxPlaceholders[index] || `Certificate ${index + 1}`}
                      </p>
                      <div className="relative bg-[#D9D9D9] rounded-[5px] h-20 md:h-[350px] w-full overflow-hidden print:h-[150px]">
                        {cert.url ? (
                          <img
                            src={cert.url}
                            alt={`Certificate ${index + 1}`}
                            className="object-cover w-full h-full"
                            crossOrigin="anonymous"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'data:image/svg+xml;base64,...';
                            }}
                          />
                        ) : (
                          <div className="flex items-center justify-center h-full">
                            <span className="print:text-[10px]">No certificate available</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {/* Land Information Section */}
            <div className="mb-6 md:mb-8 print:mb-4">
              <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4 print:text-[20px]">LAND INFORMATION</h2>
              <div className="space-y-1 md:space-y-2 print:space-y-1">
                {/* Land Type 1 */}
                {safeLandData.type1?.type && (
                  <div className="flex print:h-[40px]">
                    <div className="bg-[#E7EBEB] h-12 md:h-[100px] rounded-l-[5px] w-full flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
                      <span className="text-[8px] md:text-[32px] font-normal print:text-[14px]">{safeLandData.type1.type}</span>
                    </div>
                    <div className="relative bg-[#2E453D] h-12 md:h-[100px] rounded-r-[5px] w-24 md:w-[470px] flex items-center justify-center print:h-[40px] print:w-[150px]">
                      <span className="text-white text-[8px] md:text-[36px] underline print:text-[14px]">
                        {safeLandData.type1.size ? 
                          `${safeLandData.type1.size} ${safeLandData.type1.unit || ''}` : 
                          'Not provided'}
                      </span>
                      <span className="absolute bottom-2 right-1 md:right-4 text-white font-bold  text-[8px]  md:text-[28px] print:text-[12px] print:bottom-4 print:right-2">
                        HA
                      </span>
                    </div>
                  </div>
                )}

                {/* Land Type 2 */}
                {safeLandData.type2?.type && (
                  <div className="flex print:h-[40px]">
                    <div className="bg-[#E7EBEB] h-12 md:h-[100px] rounded-l-[5px] w-full flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
                      <span className="text-[8px] md:text-[32px] font-normal print:text-[14px]">{safeLandData.type2.type}</span>
                    </div>
                    <div className="relative bg-[#2E453D] h-12 md:h-[100px] rounded-r-[5px] w-24 md:w-[470px] flex items-center justify-center print:h-[40px] print:w-[150px]">
                      <span className="text-white  text-[8px] md:text-[36px] underline print:text-[14px]">
                        {safeLandData.type2.size ? 
                          `${safeLandData.type2.size} ${safeLandData.type2.unit || ''}` : 
                          'Not provided'}
                      </span>
                      <span className="absolute bottom-2 right-1 md:right-4 text-white font-bold  text-[8px] md:text-[24px] print:text-[12px] print:bottom-4 print:right-2">
                        HA
                      </span>
                    </div>
                  </div>
                )}
                {/* Land Registration */}
                <div className="flex print:h-[40px]">
                  <div className="bg-[#E7EBEB] h-12 md:h-[100px] rounded-l-[5px] w-full flex items-center px-2 md:px-4 print:h-[40px] print:px-2">
                    <span className="text-[8px] md:text-[32px] font-normal print:text-[14px]">Land Registration No</span>
                  </div>
                  <div className="bg-[#2E453D] h-12 md:h-[100px] rounded-r-[5px] w-24 md:w-[470px] flex items-center justify-center print:h-[40px] print:w-[150px]">
                    <span className="text-white text-[8px] md:text-[36px] underline print:text-[14px]">
                      {safeLandData.erfNumber || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Membership Section */}
            <div className="mb-6 md:mb-8 md:mt-16 print:mb-4 print:mt-6">
              <h2 className="text-[8px] md:text-[36px] font-bold mb-3 md:mb-4 print:text-[20px]">MEMBERSHIPS, AFFLIATIONS, GROUPS AND ASSOCIATION</h2>
              <h2 className="text-[8px] md:text-[36px] font-bold mb-2 print:text-[20px]">Membership</h2>
              <ul>
                {safeMembershipData.selected ? (
                  <li className="text-[6px] md:text-[36px] font-bold mt-2 md:mt-5 print:text-[14px] print:mt-2"><span className="text-[#979797] font-bold">Membership | </span>{safeMembershipData.selected}</li>
                ) : safeMembershipData.custom ? (
                  <li className="text-[6px] md:text-[36px] print:text-[14px]">{safeMembershipData.custom}</li>
                ) : (
                  <li className="text-[6px] md:text-[36px] print:text-[14px]">Not provided</li>
                )}
              </ul>
            </div>

            {/* Experience Section */}
            <div className="mb-6 md:mb-8 md:mt-16 print:mb-4 print:mt-10">
              <h2 className="text-[8px] md:text-[36px] font-bold mb-2 print:text-[20px]">Personal Group or Cooperative Experience</h2>
              <ul>
                {selectedExperience && selectedExperience.length > 0 ? (
                  selectedExperience.map((exp, index) => (
                    <li key={index} className="text-[6px] md:text-[36px] md:mt-3 mt-2 print:text-[14px] print:mt-2">{exp}</li>
                  ))
                ) : (
                  <li className="text-[6px] md:text-[36px] print:text-[14px]">Not provided</li>
                )}
              </ul>
            </div>

            {/* Areas of Focus */}
            <div className="mb-6 md:mb-4 md:mt-16 print:mb-4 print:mt-10">
              <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-2 print:text-[20px]">Areas of Focus</h2>
              <ul>
                {safeSectionD.focusSelected && safeSectionD.focusSelected.length > 0 ? (
                  safeSectionD.focusSelected.map((focus, index) => (
                    <li key={index} className=" text-[6px] md:text-[36px] md:mt-3 mt-2 print:text-[14px] print:mt-2">{focus}</li>
                  ))
                ) : (
                  <li className="text-[6px] md:text-[36px] print:text-[14px]">Not provided</li>
                )}
              </ul>
              {safeSectionD.selectedType && (
                <div className="mt-2 md:mt-2 print:mt-2">
                  <p className="text-[6px] md:text-[36px] print:text-[14px]">{safeSectionD.selectedType}</p>
                </div>
              )}
            </div>

            {/* Industry Activity Survey */}
            <div className="mb-6 md:mb-10 md:mt-10 print:mb-4 print:mt-5">
              <h2 className="text-[8px] md:text-[36px] font-bold text-black mb-3 md:mb-4 print:text-[20px]">Industry Activity Survey</h2>
              <p className="text-[6px] md:text-[36px] font-normal leading-[0.90] mb-2 text-[#979797] print:text-[14px]">
                What would you like to achieve (your vision and goals) in your enterprise pursuits and activities?
              </p>
              <p className="text-[6px] md:text-[36px] font-bold mb-4 md:mb-6 mt-3 print:text-[14px] print:mt-4">{safeIndustry.vision}</p>

              {/* Challenges Section */}
              <div>
                <h3 className="text-[8px] md:text-[32px] font-bold mb-3 md:mb-4 md:mt-10 print:text-[18px] print:mt-10">INDUSTRY ACTIVITY SURVEY - CHALLENGES</h3>
      
                {safeIndustry.selectedChallenges && safeIndustry.selectedChallenges.length > 0 ? (
                  <div className="space-y-2 md:space-y-4 print:space-y-2">
                    {safeIndustry.selectedChallenges.map((challenge, index) => (
                      <div key={index} className="">
                        <h4 className="text-[8px] md:text-[28px] font-bold">{challenge.title}</h4>
                        <p className="text-[6px] md:text-[24px] mt-1 md:mt-2">{challenge.description}</p>
                        <p className="text-[6px] md:text-[24px] mt-1 md:mt-2 text-[#2E453D] font-medium">
                          {challenge.solution}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-[6px] md:text-[24px]">No challenges selected</p>
                )}
              </div>
            </div>

            {/* Location Section */}
         {/* Location Section */}
<h1 className="text-[8px] md:text-[36px] font-bold">
  LOCATION
</h1>
<div className="mt-2 md:mt-3 print:mb-6 print:mt-3 flex items-center space-x-2 md:space-x-3">
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png"
    alt=".."
    className="w-4 h-4 md:w-[37px] md:h-[37px]"
  />
  <h1 className="text-sm mt-1 md:text-[36px] font-bold">
    Set Location
  </h1>
<div className="mb-8 print:mb-12"></div> 
<div className="mb-8 md:h-[40px] print:h-[30px]"></div> {/* Added space after location */}
{/* Added space after location */}

</div>
<LocationPicker readOnly />
            
            {/* Disclaimer */}
            <div className="mt-6 md:mt-5 pt-2 md:pt-4">
              <p className="text-[6px] md:text-[24px] leading-[1.20]">
                <span className='text-black font-bold '>Disclaimer: </span>Users are advised to verify all entries independently and consult with their financial or legal advisors before making any decisions based on the information provided. Farmnet shall not be held liable for any loss or damage arising directly or indirectly from the use of or reliance on this statement.
              </p>
            </div>
            
            <a href='/' className='flex justify-end text-[8px] md:text-[24px] mt-3 md:mt-1'>
              Terms & Conditions apply
            </a>
            
            {/* Closing Banner */}
            <div className="bg-[#2E453D] flex md:flex-row items-center justify-between px-2 md:px-4 mt-3 md:mt-1 shadow-black/40 shadow-md h-auto md:h-[110px] py-2 md:py-0">
              <div className="flex items-center">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748543265/FarmNet_Logo_Green_3_e3louy.png"
                  alt="Ad-Luck Holdings Logo"
                  className="w-20 md:w-[280px] h-4 md:h-[50px] object-contain"
                />
                <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins ml-2 md:ml-4">
                  +254702157000
                </span>
              </div>
              <div>
                <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins">
                  |    www.farmnet.africa
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showSharePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Share Registration</h3>
              <button 
                onClick={() => setShowSharePopup(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes />
              </button>
            </div>
            
            {!pdfDownloaded ? (
        <div className="text-center py-4">
          <p className="mb-4">Preparing PDF for sharing...</p>
          <button 
            onClick={handleDownloadPDF}
            className="bg-[#2E453D] text-white px-4 py-2 rounded"
            disabled={isDownloading}
          >
            {isDownloading ? 'Downloading...' : 'Download PDF First'}
          </button>
        </div>
      ) : (
        <>
          <div className="bg-green-100 text-green-800 p-3 rounded-md mb-4 text-center">
            PDF ready for sharing!
          </div>
          
          <div className="grid grid-cols-3 gap-4">
            <button 
              onClick={() => handleShare('whatsapp')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaWhatsapp className="text-green-500 text-3xl mb-2" />
              <span>WhatsApp</span>
            </button>
            <button 
              onClick={() => handleShare('facebook')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaFacebook className="text-blue-600 text-3xl mb-2" />
              <span>Facebook</span>
            </button>
            <button 
              onClick={() => handleShare('twitter')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaTwitter className="text-blue-400 text-3xl mb-2" />
              <span>Twitter</span>
            </button>
            <button 
              onClick={() => handleShare('linkedin')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaLinkedin className="text-blue-700 text-3xl mb-2" />
              <span>LinkedIn</span>
            </button>
            <button 
              onClick={() => handleShare('email')}
              className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
            >
              <FaEnvelope className="text-gray-600 text-3xl mb-2" />
              <span>Email</span>
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)}
    </div>
  );
};

export default DocumentRegistrationPage;